module.exports = __webpack_public_path__ + "static/media/green1.83fb12f5.jpg";